import React from "react";
import { APP_NAME } from "configs/AppConfig";

export default function Footer() {
  const openPolicyTab = (url) => {
    window.open(url, "_blank");
  };
  return (
    <footer className="footer">
      <span>
        Copyright &copy; {`${new Date().getFullYear()}`}{" "}
        <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights
        reserved.
      </span>
      <div>
        <a
          className="text-gray"
          href="/#"
          onClick={(e) => {
            e.preventDefault();
            openPolicyTab(
              "https://www.lowe-and-fletcher.co.uk/terms-and-conditions/"
            );
          }}
        >
          Terms & Conditions
        </a>
        <span className="mx-2 text-muted"> | </span>
        <a
          className="text-gray"
          href="/#"
          onClick={(e) => {
            e.preventDefault();
            openPolicyTab(
              "https://www.lowe-and-fletcher.co.uk/privacy-policy/"
            );
          }}
        >
          Privacy Policy
        </a>
      </div>
    </footer>
  );
}
